import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Stack } from "@mui/material";

import { API, graphqlOperation } from "aws-amplify";
import {
  getFinancialYear,
  listAccountGroupMaster,
  listFinancialYear,
  listFinancialYearStatus,
  listUserPreference,
} from "../../graphql/queries";
import { createFinancialYearStatus } from "../../graphql/mutations";
import YearEndClosingandFreezing from "../../components/modals/YearEndClosingandFreezing";
import moment from "moment";
import { showErrorSnackbar } from "../../components/snackBar/snakbar";
import { useDispatch, useSelector } from "react-redux";
import { setCloseBookFY } from "../../redux/reducers/closeBookFYDetails";

function CloseBooksOfAccounts({ top }) {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [selectButton, setSelectButton] = useState("");
  const [financialYear, setFinancialYear] = useState("");
  const [balanceSheetData, setBalanceSheetData] = useState();
  const [financialYearDetails, setFinancialYearDetails] = useState([]);
  const [listFyStatusData, setListFyStatusData] = useState();

  const [currentFYPreview, setCurrentFYPreview] = useState("");
  const [currentFY, setCurrentFY] = useState();
  const [nextFY, setNextFY] = useState();
  const [FYList, setFYList] = useState([]);
  const [nextFYPreview, setNextFYPreview] = useState("");

  const closeBookFYState = useSelector(
    (state) => state?.closeBookFYStateReducer
  );
  async function getCurrentFinancialYearDetailsFn() {
    try {
      const graphqlUSerRes = await API.graphql(
        graphqlOperation(listUserPreference)
      );
      let FYID = graphqlUSerRes?.data?.listUserPreference?.find(
        (item) => item?.AttributeTypeCD === "SelectedFinYear"
      );

      const graphqlCurrentFYRes = await API.graphql(
        graphqlOperation(getFinancialYear, {
          FinancialYearID: FYID?.AttributeValue,
        })
      );

      let FYDEtails = graphqlCurrentFYRes?.data?.getFinancialYear;
      setCurrentFY(FYDEtails);
      dispatch(setCloseBookFY({ key: "currentFY", data: FYDEtails }));
      let fYPreview = `${moment(FYDEtails?.StartDate * 1000).format(
        "DD MMM YYYY"
      )} to ${moment(FYDEtails?.EndDate * 1000).format("DD MMM YYYY")} `;
      setCurrentFYPreview(fYPreview);
    } catch (error) {
      showErrorSnackbar(
        "An error occurred while fetching financial year details. Please try again later."
      );
    }
  }

  async function fetchFinancialYearList() {
    try {
      const graphqlFYlistRes = await API.graphql(
        graphqlOperation(listFinancialYear)
      );
      setFYList(graphqlFYlistRes?.data?.listFinancialYear);
    } catch (error) {
      showErrorSnackbar(
        "An error occurred while fetching financial year list. Please try again later."
      );
    }
  }

  function checkNextFy() {
    const currentStartYear = moment(currentFY?.StartYear, "YYYY");
    const currentEndYear = moment(currentFY?.EndYear, "YYYY");
    const nextStartYear = currentStartYear
      .clone()
      .add(1, "year")
      .format("YYYY");
    const nextEndYear = currentEndYear.clone().add(1, "year").format("YYYY");
    const findNextYear = FYList.find(
      (fy) => fy.StartYear === nextStartYear && fy.EndYear === nextEndYear
    );
    if (findNextYear) {
      dispatch(setCloseBookFY({ key: "nextFY", data: findNextYear }));
      let nextfYPreview = `${moment(findNextYear?.StartDate * 1000).format(
        "DD MMM YYYY"
      )} to ${moment(findNextYear?.EndDate * 1000).format("DD MMM YYYY")} `;
      setNextFYPreview(nextfYPreview);
    }
  }

  async function fetchlistFinancialYearStatusFn() {
    try {
      const graphqlFYStatusRes = await API.graphql(
        graphqlOperation(listFinancialYearStatus)
      );
      let list = graphqlFYStatusRes?.data?.listFinancialYearStatus || [];

      if (list.length > 0) {
        const currentFYStatus = list.find(
          (ele) => ele?.FinancialYearID === currentFY?.FinancialYearID
        );
        dispatch(setCloseBookFY({ key: "FYStatus", data: currentFYStatus }));
      } else {
        const FYStatusObj = {
          FinancialYearID: currentFY?.FinancialYearID,
          StatusTypeCD: "",
          StatusValue: "",
        };
        const graphqlCreateFYStatusRes = await API.graphql(
          graphqlOperation(createFinancialYearStatus, {
            createFinancialYearStatusInput: FYStatusObj,
          })
        );
        dispatch(
          setCloseBookFY({
            key: "FYStatus",
            data: graphqlCreateFYStatusRes?.data?.createFinancialYearStatus,
          })
        );
      }
    } catch (error) { }
  }
  let isFyearMounted = true;
  useEffect(() => {
    if (isFyearMounted) {
      fetchFinancialYearList();
      getCurrentFinancialYearDetailsFn();
      isFyearMounted = false;
    }
    return () => {
      isFyearMounted = false;
    };

  }, []);

  useEffect(() => {
    if (currentFY && FYList.length > 0) {
      checkNextFy();
      fetchlistFinancialYearStatusFn();
    }
  }, [currentFY, FYList]);

  const handleButtonClick = (type) => {
    setOpenModal(true);
    setSelectButton(type);
  };

  return (
    <Box
      sx={{
        paddingTop: `${top}px`,
        paddingLeft: { xs: "8px", sm: "70px", lg: "80px" },
        paddingRight: { xs: "8px", lg: "30px" },
        paddingBottom: "8px",
        boxSizing: "content-box",
      }}
    >
      <Box
        sx={{
          backgroundColor: "background.paper",
          minHeight: "550px",
          borderRadius: "10px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: { md: "space-between" },
            alignItems: { md: "center" },
            padding: "25px",
          }}
        >
          <Box
            sx={{
              marginBottom: { xs: 2, md: 0 },
              marginRight: { xs: 0, md: 2 },
            }}
          >
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Financial year to transfer the closing balances to next year
            </Typography>
            <Typography
              variant="body1"
              sx={{ marginBottom: 2, fontWeight: "bold" }}
            >
              {currentFYPreview}
            </Typography>
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={{ xs: 1, md: 3 }}
            >
              <Button
                variant="outlined"
                onClick={() => handleButtonClick("transfer")}
                disabled={
                  closeBookFYState?.FYStatus?.StatusValue === "transfer" ||
                  closeBookFYState?.FYStatus?.StatusValue === "frozen"
                }
              >
                Transfer
              </Button>

              {closeBookFYState?.FYStatus &&
                closeBookFYState?.FYStatus?.StatusValue === "frozen" ? (
                <Button
                  variant="outlined"
                  onClick={() => handleButtonClick("lock&freeze")}
                >
                  Unlock and Unfreeze Data
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  onClick={() => handleButtonClick("lock&freeze")}
                >
                  Lock & Freeze Data
                </Button>
              )}
            </Stack>
          </Box>
          <Box>
            <Button variant="outlined">
              View ledgers having closing Balance
            </Button>
          </Box>
        </Box>
      </Box>
      <YearEndClosingandFreezing
        open={openModal}
        item={selectButton}
        nextFYPreview={nextFYPreview}
        setOpenModal={setOpenModal}
      />
    </Box>
  );
}

export default CloseBooksOfAccounts;
